import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux'
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import Beatloader from '../../../../Common/BeatLoader';
import {
    getTutorStudyMaterialImageListData, getTutorStudyMaterialPdfListData, getTutorStudyMaterialVideoListData, getTutorStudyMaterialPptListData,
    getTutorStudyMaterialDocListData
} from '../../../../Redux/action/TutorAction';
import VideoModal from './VideoModal';
const host = process.env.REACT_APP_API_SERVER
const ViewStudyMaterial = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { b64id } = useParams();



    // useEffect(() => {
    //     dispatch(getTutorStudyMaterialImageListData(query.toString()))
    //     dispatch(getTutorStudyMaterialPdfListData(query.toString()))
    //     dispatch(getTutorStudyMaterialVideoListData(query.toString()))
    // }, [query]);

    useEffect(() => {
        try {

            const query = atob(b64id);

            dispatch(getTutorStudyMaterialImageListData(query.toString()))
            dispatch(getTutorStudyMaterialPdfListData(query.toString()))
            dispatch(getTutorStudyMaterialVideoListData(query.toString()))
            dispatch(getTutorStudyMaterialPptListData(query.toString()))
            dispatch(getTutorStudyMaterialDocListData(query.toString()))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);

    const [video, setVideo] = useState();
    const [image, setImage] = useState();
    const [pdf, setPdf] = useState();
    const handleVideoClick = (v) => {

        const pathParts = v.split('/');
        const fileName = pathParts.pop();
        const encodedFileName = encodeURIComponent(fileName);
        const enc = `${host}${pathParts.join('/')}/${encodedFileName}`
        setVideo(enc)

    }
    const handleImageClick = (v) => {

        const enc = `${host}${v}`
        setImage(enc)

    }

    const handlePdfClick = (materialFile) => {
        if (!materialFile) return;
        // Directly use materialFile with host
        window.open(`${host}${materialFile}`, "_blank", "noopener,noreferrer");
    };


    // const handlePdfClick = (materialFile) => {
    //     if (!materialFile) return; // Check if the materialFile exists

    //     const pathParts = materialFile.split('/');
    //     const fileName = pathParts.pop(); // Get the file name
    //     const encodedFileName = encodeURIComponent(fileName); // Encode file name
    //     const encodedPath = `${host}${pathParts.join('/')}/${encodedFileName}`;



    //     // Open the encoded URL in a new tab
    //     window.open(encodedPath, "_blank", "noopener,noreferrer");
    // };

    const handleDocumentClick = (materialFile) => {
        if (!materialFile) return;
        window.open(`${host}${materialFile}`, "_blank", "noopener,noreferrer");
    };

    const {
        loadingTutorStudyMaterialVideoListApi,
        TutorStudyMaterialVideoListApiData,
        TutorStudyMaterialVideoListApiError,

        loadingTutorStudyMaterialImageListApi,
        TutorStudyMaterialImageListApiData,
        TutorStudyMaterialImageListApiError,

        loadingTutorStudyMaterialPdfListApi,
        TutorStudyMaterialPdfListApiData,
        loadingTutorStudyMaterialPptListApi,
        TutorStudyMaterialPptListApiData,
        loadingTutorStudyMaterialDocListApi,
        TutorStudyMaterialDocListApiData,
        TutorStudyMaterialPdfListApiError
    } = useSelector(state => state?.TutorReducer);

    return (
        <div>
            <style>{`
.study-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    border-bottom: none !important;
}

.study-tabs .nav-item {
    flex: 1 1 calc(20% - 12px);
    min-width: 180px;
}

.study-tabs .nav-link {
    width: 100%;
    padding: 0;
    border: none !important;
    background: transparent !important;
}

.study-tabs .card {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    transition: 0.3s ease;
}

.study-tabs .card-body {
    padding: 14px;
}

.study-tabs .icon-sec {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    height: 100%;
}

.study-tabs h5 {
    font-size: 15px;
    font-weight: 600;
}

.study-tabs .nav-link.active .card {
    background: #357edd;
    color: #fff;
    border: 1px solid #2e578d;
}

.study-tabs .card:hover {
    transform: translateY(-3px);
}

@media (max-width: 991px) {
    .study-tabs .nav-item {
        flex: 1 1 calc(50% - 12px);
    }
}

@media (max-width: 576px) {
    .study-tabs .nav-item {
        flex: 1 1 100%;
    }

    .study-tabs h5 {
        font-size: 14px;
    }

    .study-tabs .card-body {
        padding: 10px;
    }
}
`}</style>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;View Study Material
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">


                            <main className="px-3 py-4">
                                <div className="study-material-sec">
                                    {/* <ul className="nav nav-tabs" id="myTab" role="tablist"> */}
                                    <ul
                                        className="nav nav-tabs study-tabs"
                                        id="myTab"
                                        role="tablist"
                                    >
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="home-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#home"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                            >
                                                <div className="card" id="add-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-play" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0">Video Lession</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-image" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-start">Images</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="contact-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#contact"
                                                type="button"
                                                role="tab"
                                                aria-controls="contact"
                                                aria-selected="false"
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-file-pdf" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-start">Pdf</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="ppt-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#ppt"
                                                type="button"
                                                role="tab"
                                                aria-controls="ppt"
                                                aria-selected="false"
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-file-powerpoint" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-start">PPT</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="doc-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#doc"
                                                type="button"
                                                role="tab"
                                                aria-controls="doc"
                                                aria-selected="false"
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="fa-solid fa-file-word" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 text-start">DOC</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content p-4" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingTutorStudyMaterialVideoListApi ?
                                                <Beatloader />
                                                :
                                                <div className="table-responsive">
                                                    <table className="table bg-light mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">S.No.</th>
                                                                <th scope="col">Video Name</th>
                                                                <th scope="col">Upload date</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {TutorStudyMaterialVideoListApiData?.length > 0 ?
                                                                TutorStudyMaterialVideoListApiData?.map((data, index) => (
                                                                    <tr key={data?.id}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <td>{data?.material_name}</td>
                                                                        <td>{new Date(data?.createdAt).toDateString()}</td>
                                                                        <td>{data?.approval_status}</td>
                                                                        <td onClick={() => { handleVideoClick(data?.study_material_detail?.material_file) }}>
                                                                            <i
                                                                                className="fa-solid fa-eye "
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#videoModal"
                                                                            />
                                                                        </td>
                                                                    </tr>))
                                                                :
                                                                <tr>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col">No Data</th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                            }

                                                        </tbody>

                                                    </table>
                                                </div>
                                            }
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="profile"
                                            role="tabpanel"
                                            aria-labelledby="profile-tab"
                                        >
                                            {loadingTutorStudyMaterialImageListApi ?
                                                <Beatloader />
                                                :
                                                <div className="table-responsive">
                                                    <table className="table bg-light mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">S.No.</th>
                                                                <th scope="col">Image Name</th>
                                                                <th scope="col">Upload date</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {TutorStudyMaterialImageListApiData?.length > 0 ?
                                                                TutorStudyMaterialImageListApiData?.map((data, index) => (
                                                                    <tr key={data?.id}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <td>{data?.material_name}</td>
                                                                        <td>{new Date(data?.createdAt).toDateString()}</td>
                                                                        <td>{data?.approval_status}</td>
                                                                        <td onClick={() => { handleImageClick(data?.study_material_detail?.material_file) }}>
                                                                            <i
                                                                                className="fa-solid fa-eye "
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#imagesModal"
                                                                            />
                                                                        </td>
                                                                    </tr>))
                                                                :
                                                                <tr>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col">No Data</th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                            }

                                                        </tbody>

                                                    </table>
                                                </div>
                                            }
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="contact"
                                            role="tabpanel"
                                            aria-labelledby="contact-tab"
                                        >
                                            {loadingTutorStudyMaterialPdfListApi ?
                                                <Beatloader />
                                                :
                                                <div className="table-responsive">
                                                    <table className="table bg-light mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">S.No.</th>
                                                                <th scope="col">Pdf Name</th>
                                                                <th scope="col">Upload date</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {TutorStudyMaterialPdfListApiData?.length > 0 ?
                                                                TutorStudyMaterialPdfListApiData?.map((data, index) => (
                                                                    <tr key={data?.id}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <td>{data?.material_name}</td>
                                                                        <td>{new Date(data?.createdAt).toDateString()}</td>
                                                                        <td>{data?.approval_status}</td>
                                                                        <td onClick={() => { handlePdfClick(data?.study_material_detail?.material_file) }}>
                                                                            <a href={`${host}${data?.study_material_detail?.material_file}`} target='blank'></a> <i
                                                                                className="fa-solid fa-eye "
                                                                            // data-bs-toggle="modal"
                                                                            // data-bs-target="#pdfModal"
                                                                            />
                                                                        </td>
                                                                    </tr>))
                                                                :
                                                                <tr>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col">No Data</th>
                                                                    <th scope="col"></th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                            }

                                                        </tbody>

                                                    </table>
                                                </div>

                                            }
                                        </div>
                                        {/* PPT Tab Pane */}
                                        <div className="tab-pane fade" id="ppt" role="tabpanel">
                                            {loadingTutorStudyMaterialPptListApi ? (
                                                <Beatloader />
                                            ) : (
                                                <div className="table-responsive">
                                                    <table className="table bg-light mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">S.No.</th>
                                                                <th scope="col">PPT Name</th>
                                                                <th scope="col">Upload date</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {TutorStudyMaterialPptListApiData?.length > 0 ? (
                                                                TutorStudyMaterialPptListApiData?.map((data, index) => (
                                                                    <tr key={data?.id}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <td>{data?.material_name}</td>
                                                                        <td>{new Date(data?.createdAt).toDateString()}</td>
                                                                        <td>{data?.approval_status}</td>
                                                                        <td onClick={() => handleDocumentClick(data?.study_material_detail?.material_file)}>
                                                                            <i className="fa-solid fa-eye" />
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center">No Data</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>

                                        {/* DOC Tab Pane */}
                                        <div className="tab-pane fade" id="doc" role="tabpanel">
                                            {loadingTutorStudyMaterialDocListApi ? (
                                                <Beatloader />
                                            ) : (
                                                <div className="table-responsive">
                                                    <table className="table bg-light mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">S.No.</th>
                                                                <th scope="col">DOC Name</th>
                                                                <th scope="col">Upload date</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {TutorStudyMaterialDocListApiData?.length > 0 ? (
                                                                TutorStudyMaterialDocListApiData?.map((data, index) => (
                                                                    <tr key={data?.id}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <td>{data?.material_name}</td>
                                                                        <td>{new Date(data?.createdAt).toDateString()}</td>
                                                                        <td>{data?.approval_status}</td>
                                                                        <td onClick={() => handleDocumentClick(data?.study_material_detail?.material_file)}>
                                                                            <i className="fa-solid fa-eye" />
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center">No Data</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </main>



                        </div>
                    </div>
                </div>
            </section>

            <>
                {/* video popup */}
                <div
                    className="modal fade"
                    id="videoModal"
                    tabIndex={-1}
                    aria-labelledby="videoModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="videoModalLabel">
                                    Notes Video
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="ratio ratio-16x9">
                                    <video
                                        className="img-fluid w-100"
                                        src={video}

                                        controls
                                        playsInline
                                        loading="eager"
                                    >
                                        Your browser does not support the video tag.
                                    </video>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* images popup */}
                <div
                    className="modal fade"
                    id="imagesModal"
                    tabIndex={-1}
                    aria-labelledby="imagesModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="imagesModalLabel">
                                    Image Gallery
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    {/* Left side: Main Image with navigation */}
                                    <div className="col-lg-12 col-md-12 position-relative">
                                        {/* Main Image */}
                                        <img
                                            id="mainImage"
                                            src={image}
                                            className="img-fluid w-100 h-100 rounded"
                                            style={{ maxHeight: "500px !important" }}
                                            alt="Main Image"
                                        />
                                        {/* Left arrow */}
                                        {/* <button
                                            id="prevButton"
                                            className=" -dark position-absolute top-50 start-0 translate-middle-y"
                                            onclick="navigateImage(-1)"
                                        >
                                            <i className="bi bi-chevron-left" />
                                        </button> */}
                                        {/* Right arrow */}
                                        {/* <button
                                            id="nextButton"
                                            className=" -dark position-absolute top-50 end-0 translate-middle-y"
                                            onclick="navigateImage(1)"
                                        >
                                            <i className="bi bi-chevron-right" />
                                        </button> */}
                                    </div>
                                    {/* Right side: Image Thumbnails in Grid */}
                                    {/* <div className="col-lg-4 col-md-4">
                                        <div className="row g-2">
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img1.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 1"
                                                    onclick="changeMainImage(this.src, 0)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img2.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 2"
                                                    onclick="changeMainImage(this.src, 1)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img1.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 1"
                                                    onclick="changeMainImage(this.src, 0)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img2.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 2"
                                                    onclick="changeMainImage(this.src, 1)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img1.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 1"
                                                    onclick="changeMainImage(this.src, 0)"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <img
                                                    src="/assets/img/img2.jpg"
                                                    className="img-thumbnail img-grid"
                                                    alt="Thumbnail 2"
                                                    onclick="changeMainImage(this.src, 1)"
                                                />
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* pdf popup */}
                <div
                    className="modal fade"
                    id="pdfModal"
                    tabIndex={-1}
                    aria-labelledby="pdfModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog  modal-dialog-centered modal-lg ">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="pdfModalLabel">
                                    PDF Viewer
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body " style={{ maxHeight: 500 }}>
                                <div className="ratio ratio-4x3">
                                    <iframe
                                        src={pdf} // PDF URL from state
                                        title="PDF Document"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            maxHeight: 470, // Maximum height for the iframe
                                        }}
                                        frameBorder={0} // No border for a cleaner look
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>


        </div>
    )
}

export default ViewStudyMaterial